import { createSignal } from "solid-js";
import type { JWSource, JWTrack } from "./api/jw";

export interface EntityData {
  mediaid: string;
  title: string;
  description: string;
  poster: string;
  backdrop: string;
  sources?: JWSource[];
  tracks?: JWTrack[];
  duration?: number;
  tags?: string;
  isLive?: boolean;
}

export interface PlayerData {
  manifestUrl: string;
  title: string;
  isLive: boolean;
   tracks?: JWTrack[];
}

export const [entityState, setEntityState] = createSignal<EntityData | null>(
  null
);
export const [playerState, setPlayerState] = createSignal<PlayerData | null>(
  null
);
export const [exitPromptState, setExitPromptState] = createSignal<boolean>(false);
